const transformer = function (origin) {
  return {
    render: 'text',
    origin,
    value: origin,
  }
}

export default transformer
